import axios from 'axios'
import store from '@/store'
import storage from 'store'
import {
  VueAxios
} from './axios'
import {
  notification
} from 'ant-design-vue'
import {
  ACCESS_TOKEN,
} from '@/store/mutation-types'

const baseURL = process.env.VUE_APP_API_BASE_URL
const baseUrlPy = process.env.VUE_APP_API_PY_BASE_URL
// 创建 axios 实例
const request = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 6000 // 请求超时时间
})
// var pending = []; //声明一个数组用于存储每个请求的标识
// var cancelToken = axios.CancelToken;
// var removePending = (config) => {
  //查找数组中是否存在相同请求数目是否超过五个;存在则取消
  // let num = 0
  // for (let i = 0; i < pending.length; i++) {
  //   if (pending[i].u === config.url.split('?')[0] + '&' + config.method) {
  //     num++
  //     if (num > 5) {
  //       pending[i].f(); //执行取消操作
  //       pending.splice(i, 1); //数组移除当前请求
  //       i--
  //     }
  //   }
  // }
// }
export const pureAxios = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 6000 // 请求超时时间
})
export const py_axios = axios.create({
  baseURL: baseUrlPy, // api base_url
  timeout: 6000 // 请求超时时间
})


const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  // removePending(config);
  // 设置cancelToken对象
  // config.cancelToken = new cancelToken((c) => {
  //   pending.push({
  //     u: config.url.split('?')[0] + '&' + config.method
  //   })
  // })
  const token = storage.get(ACCESS_TOKEN);
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }

  return config
}, err)

pureAxios.interceptors.request.use(config => {
  console.log(config, 'configconfigconfig')
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)
py_axios.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)
// py_axios.defaults.headers['Content-Type'] = 'application/json'
// response interceptor
request.interceptors.response.use((response) => {
  if (response.status == 200) {
    // for (let p in pending) {
    //   if (pending[p].u === response.config.url.split('?')[0] + '&' + response.config.method) {
    //     pending.splice(p, 1)
    //   }
    // }
    if (response.data.code == 401) {
      if (localStorage.getItem('notified') != 1) {
        notification.error({
          message: '您的登录状态已过期，请重新登录！',
        })
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
        localStorage.setItem('notified', 1)
      }
    }
    return response.data
  }
}, err)
py_axios.interceptors.response.use((response) => {
  if (response.status == 200) {
    if (response.data.code == 401) {
      if (localStorage.getItem('notified') != 1) {
        notification.error({
          message: '您的登录状态已过期，请重新登录！',
        })
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
        localStorage.setItem('notified', 1)
      }
    }
    return response.data
  }
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request, py_axios)
  }
}
//java 固定下载文件二进制流
export const download_file_java = (types, path, fileName) => {
  var headers = {
    'token': storage.get(ACCESS_TOKEN),
    'Content-Type': "application/json;charset=utf-8"
  }
  return new Promise((resolve, reject) => {
    axios.post(
      process.env.VUE_APP_API_BASE_URL + `/file/file/download?bucketName=${types}&path=${path}&fileName=${fileName}`, {}, {
        responseType: 'blob',
        headers: headers
      }
    ).then(res => {
      resolve(res)
    })
  })
}
export default request

export {
  installer as VueAxios,
  request as axios,
  py_axios as pyAxios
}